import CROSSHAIR from './tools/crosshair.js';
import FIBONACCI from './tools/fibonacci.js';

/**
 * Enums associated with various tools
 * @readonly
 * @enum {object}
 */
export default Object.freeze({
	/** Enums associated with the Crosshair tool */
	CROSSHAIR,
	/** Enums associated with the Fibonacci Line tool */
	FIBONACCI
});
